import { Client, ContactLanguages } from "briefpoint-client";
import { useClientApi } from "hooks/useApi";
import { useCallback, useEffect, useState } from "react";

export default function useClient({ id, firmId }: { id?: string; firmId?: string }) {
  const clientApi = useClientApi();
  const [client, setClient] = useState<Client | undefined>(undefined);

  useEffect(() => {
    if (firmId && id) {
      clientApi.clientGet({ firmId, id }).then(setClient);
    }
  }, [id, clientApi, firmId]);

  const updateClientLanguage = useCallback(
    async (lang: ContactLanguages) => {
      if (client && firmId) {
        const updatedClient = {
          ...client,
          contactLanguage: lang,
        };
        setClient(updatedClient);
        await clientApi.clientPut({
          id: client.id!,
          firmId,
          client: updatedClient,
        });
      }
    },
    [client, clientApi, firmId]
  );

  return { client, updateClientLanguage };
}